import { useCallback, useMemo, useState } from "react";

import { getPosition } from "../../../../utils";

const useMenu = ({
    clickedElement,
    currentIframeRef,
    setClickedElement,
    onElementWithText,
    onTextAnyElement
}) => {
    const [ isOpen, setIsOpen ] = useState(false);

    const handleElementWithText = useCallback(
        (el) => {
            el.preventDefault();
            onElementWithText();
            setIsOpen(false);
            setClickedElement(null);
        },
        [ onElementWithText, setClickedElement ]
    );

    const handleTextAnyElement = useCallback(
        (el) => {
            el.preventDefault();
            onTextAnyElement();
            setIsOpen(false);
            setClickedElement(null);
        },
        [ onTextAnyElement, setClickedElement ]
    );

    const menuItems = useMemo(
        () => ([
            {
                children: "Should contain this element with any text",
                title: "Click to add xPath",
                onClick: handleElementWithText
            },
            {
                children: "Should contain this text in any element",
                title: "Click to add text",
                onClick: handleTextAnyElement
            }
        ]),
        [ handleElementWithText, handleTextAnyElement ]
    );

    const menuPosition = useMemo(
        () => {
            if(clickedElement && currentIframeRef) {
                return getPosition(clickedElement, currentIframeRef);
            }

            return {};
        },
        [ clickedElement, currentIframeRef ]
    );

    return useMemo(
        () => ({
            menuPosition,
            menuItems,
            isOpen,
            onMenuOpen: () => setIsOpen(true),
            onMenuClose: () => setIsOpen(false)
        }),
        [ isOpen, menuItems, menuPosition ]
    );
};

export default useMenu;
